import { useMutation } from 'src/core/api/hooks/useMutation';

import { getPayableRulesQueryKey } from './useGetPayableRules';

type UpdatePayableRulePayload = {
  conditions: {
    field: string;
    operator: string;
    value: [string, ...string[]] | 'all' | null | undefined | unknown;
  }[];
  outputs: {
    [key: string]: string | { [key: string]: string };
  };
  icon: string;
  state: 'draft' | 'published';
  name: string;
  fromVersion: number;
  endpointParams: {
    payableRuleId: string;
  };
};

export const useUpdatePayableRule = () => {
  return useMutation<UpdatePayableRulePayload>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: ({ payableRuleId }) =>
        `/bookkeeping/automation/payable-rules/${payableRuleId}`,
      method: 'put',
    },
    options: {
      throwOnError: true,
      onSuccess: ({ client }) => {
        client.invalidateQueries(getPayableRulesQueryKey);
      },
    },
  });
};
